import React from "react";
import { CalendarDays, Clock, MapPin, ArrowRight, Heart } from "lucide-react";
import { Reveal } from "@/components/Ornaments";

const EventDetails = ({ data }) => {
  const v = data.venue;
  return (
    <>
      <Reveal>
        <section data-testid="event-details">
          <div className="gold-frame overflow-hidden bg-white">
            <div className="relative h-60 sm:h-72">
              <img alt={v.title} className="h-full w-full object-cover" loading="lazy" src={v.image} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/25" />
              <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center text-white">
                <p className="eyebrow !text-white/75">{v.eyebrow}</p>
                <h3 data-testid="venue-title" className="mt-3 text-2xl font-medium leading-snug drop-shadow-md sm:text-3xl">
                  {v.title.split("\n").map((l, i) => (
                    <React.Fragment key={i}>
                      {l}
                      {i < v.title.split("\n").length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </h3>
              </div>
            </div>
            <div className="flex flex-col items-center gap-4 px-6 py-6">
              <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1 text-sm text-[#57534E]">
                <span className="flex items-center gap-2">
                  <CalendarDays className="text-[#B0607A]" width={15} height={15} />
                  {v.date}
                </span>
                <span className="flex items-center gap-2">
                  <Clock className="text-[#B0607A]" width={15} height={15} />
                  {v.time}
                </span>
              </div>
              <p className="text-xs text-[#78716C]">{v.address}</p>
              <a
                data-testid="location-maps-button"
                href={v.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 border border-[#E0C2CE] bg-white px-8 py-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#1C1917] shadow-sm transition-all hover:bg-[#FDF4F7] hover:shadow-md"
              >
                <MapPin className="text-[#B0607A]" width={14} height={14} />
                ლოკაცია
                <ArrowRight width={14} height={14} />
              </a>
            </div>
          </div>
        </section>
      </Reveal>

      <section data-testid="date-strip" className="border-y border-[#ECD3DC] bg-gradient-to-r from-transparent via-[#FBF3F6] to-transparent py-6">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1">
          <span className="font-display text-sm tracking-[0.34em] text-[#57534E]">{data.date.short}</span>
          <Heart className="text-[#D492A6]" width={15} height={15} fill="currentColor" />
          <span className="font-script text-4xl leading-none text-[#7E4A5C]">Wedding Day</span>
        </div>
      </section>
    </>
  );
};

export default EventDetails;
